<template>
  <Modal layout="aside">
    <div class="container">
      <div class="header">
        <div class="logo">
          brut all over Vienna
        </div>
      </div>
      <div class="content">
        <div class="about">
          <BlockContent :blocks="settings.about" />
        </div>
        <div class="legal">
          <BlockContent :blocks="settings.legal" />
        </div>
      </div>
      <SvgIcon icon="brut" :unwrap="false" />
    </div>
  </Modal>
</template>

<script>
import BlockContent from 'sanity-blocks-vue-component'
import { mapState } from 'vuex'

import Modal from '@/components/Modal'
import SvgIcon from '@/components/SvgIcon'

export default {
  name: 'SiteInfoOverlay',
  components: {
    BlockContent,
    Modal,
    SvgIcon
  },
  computed: {
    ...mapState(['settings'])
  },
  metaInfo() {
    const title = 'Info'

    return {
      title,
      meta: [
        { vmid: 'og:title', name: 'og:title', content: title },
        { vmid: 'twitter:title', name: 'twitter:title', content: title }
      ]
    }
  }
}
</script>

<style scoped>
.container {
  padding: var(--page-padding);
  padding-top: 0;
}
.header {
  padding-top: var(--page-padding);
  padding-bottom: calc(var(--page-padding) * 2);
}
.logo {
  @mixin type-jumbo;
  vertical-align: baseline;
  @mixin type-medium-lineheight;
}
.content {
  p,
  ul {
    margin-top: 1.2em;
  }
  h2,
  h3 {
    margin-top: 2.3em;
    margin-bottom: 1.2em;
    font-weight: 600;
  }
  :first-child {
    margin-top: 0;
  }
}
.about {
  @mixin type-larger--serif;
}
.legal {
  @mixin type-smaller;
  padding-top: 5em;
}
/deep/ .icon-brut {
  @mixin brut-list-icon;
}
@mixin breakpoint-medium {
  .header {
    padding-bottom: var(--page-padding);
    min-height: var(--header-height);
    transform: translateY(-0.35em);
  }
}
@media only print {
  /deep/ .icon-brut {
    display: none;
  }
}
</style>
